import { gsap } from "gsap";

export default class Menu {
  private _menus_level_1: NodeList;
  private _menu_container: HTMLElement;

  constructor() {
    this.init();
  }

  private init() {
    this._menu_container = document.querySelector(".c-main-nav__nav");
    if (!this._menu_container) {
      console.warn("Menu container (.c-main-nav__nav) not found");
      return;
    }

    this._menus_level_1 = document.querySelectorAll(
      ".c-main-nav__list-item.has-children"
    );
    this.addEventListeners();
    this.centerDesktopMenu();
  }

  private addEventListeners() {
    if (!this._menu_container) return;

    this._menu_container.addEventListener("click", this.menuClickHandler);
    window.addEventListener("resize", this.centerDesktopMenu);
  }

  private menuClickHandler = (e: MouseEvent) => {
    const navLink: HTMLElement = (e.target as HTMLElement).closest(
      ".c-main-nav__list-item"
    );

    if (!navLink) return;

    const isAlreadyOpen =
      !navLink.classList.contains("inactive") &&
      Array.from(this._menus_level_1).every(
        (singleNavLink: HTMLElement) =>
          singleNavLink === navLink ||
          singleNavLink.classList.contains("inactive")
      );

    if (isAlreadyOpen) {
      this.resetMenu();
      return;
    }

    this._menus_level_1.forEach((singleNavLink: HTMLElement) => {
      this.closeSubmenu(singleNavLink as HTMLElement);
    });

    this.openSubmenu(navLink as HTMLElement);
  };

  private openSubmenu(navLink: HTMLElement) {
    if (!navLink) return;

    const submenu = navLink.querySelector(
      ".c-main-nav__submenu"
    ) as HTMLElement;

    navLink.classList.remove("inactive");

    if (submenu.clientHeight > 0) return;

    const isMobile = window.matchMedia("(max-width: 764px)").matches;

    if (isMobile) {
      gsap.to(submenu, {
        height: submenu.scrollHeight * 2,
        duration: 0.2,
        ease: "quad4.out",
        opacity: 1
      });
    } else {
      gsap.to(submenu, {
        height: submenu.scrollHeight,
        duration: 0.2,
        ease: "quad4.out",
        opacity: 1
      });
    }
  }

  private closeSubmenu(navLink: HTMLElement) {
    if (!navLink) return;

    const submenu = navLink.querySelector(
      ".c-main-nav__submenu"
    ) as HTMLElement;

    navLink.classList.add("inactive");

    if (!submenu) return;

    gsap.to(submenu, {
      height: 0,
      opacity: 0,
      duration: 0.2,
      ease: "quad4.out"
    });
  }

  private resetMenu() {
    this._menus_level_1.forEach((singleNavLink: HTMLElement) => {
      this.closeSubmenu(singleNavLink);
      singleNavLink.classList.remove("inactive");
    });
  }

  private centerDesktopMenu() {
    const navContainer = document.querySelector(
      ".c-main-nav__nav"
    ) as HTMLElement;
    const navList = navContainer.querySelector(
      ".c-main-nav__list"
    ) as HTMLElement;

    const navContainerHeight = navContainer.clientHeight;
    const navListHeight = navList.clientHeight;
    const marginTop = navContainerHeight / 2 - navListHeight / 2;
    const isMobile = window.matchMedia("(max-width: 764px)").matches;

    if (isMobile) {
      gsap.to(navList, {
        marginTop: 0,
        duration: 0.2,
        ease: "quad4.out"
      });
    } else {
      gsap.to(navList, {
        marginTop: marginTop,
        duration: 0.2,
        ease: "quad4.out"
      });
    }
  }
}
